import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import PythPriceFacet from '../abis/PythPriceFacet';
import { getContractAddress } from '../constants';

export const getPythPriceFacet = ({
  publicClient,
  walletClient,
  chainId,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: PythPriceFacet,
    address: address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
